module.exports = __webpack_public_path__ + "static/img/5.66fe9dcc.png";